import type { SchemaFieldExpression } from "@/entities/schema";

import { Form } from "antd";
import { useState } from "react";

import { useEvaluateExpressionField } from "@/modules/expression-field";
import { useSchemaViewerFormLabels } from "@/modules/schema-viewer/schema-viewer-form";

import { getSchemaViewerFieldPrintExpressions } from "./schema-viewer-field-expression-label.helper";

const { useFormInstance } = Form;

export const useSchemaViewerFieldExpressionLabel = (
  expressionSchema: SchemaFieldExpression
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const form = useFormInstance();
  const { result } = useEvaluateExpressionField(expressionSchema, form);
  const { schemaFormLabels } = useSchemaViewerFormLabels();

  const { expressionWithLabels, expressionWithValues } =
    getSchemaViewerFieldPrintExpressions({
      expressionSchema,
      form,
      schemaFormLabels,
      result,
    });

  return {
    isModalOpen,
    expressionWithLabels,
    expressionWithValues,
    showModal: () => setIsModalOpen(true),
    handleClose: () => setIsModalOpen(false),
  };
};
